export const SEND_MESSAGE = "SEND_MESSAGE";
export const GET_TALKS = "GET_TALKS";
export const DELETE_TALKS = "DELETE_TALKS";